import React from 'react';

interface BlobBackgroundProps {
  variant?: 'hero' | 'subtle';
  className?: string;
}

// Calca app/obros/lib/widgets/obros_blob_background.dart: blobs circulares difuminados,
// posicionados absolutos detrás del contenido (usar con un wrapper `relative`).
export const BlobBackground: React.FC<BlobBackgroundProps> = ({ variant = 'subtle', className = '' }) => {
  const hero = variant === 'hero';

  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      <div
        className={`absolute rounded-full bg-primary-300/40 blur-3xl ${hero ? '-top-24 -left-24 w-96 h-96' : '-top-16 -left-16 w-64 h-64'}`}
      />
      <div
        className={`absolute rounded-full bg-cream/70 blur-3xl ${hero ? 'top-1/3 -right-20 w-80 h-80' : 'top-1/4 -right-12 w-52 h-52'}`}
      />
      {hero && <div className="absolute -bottom-24 left-1/4 w-72 h-72 rounded-full bg-primary-200/50 blur-3xl" />}
    </div>
  );
};
